<script lang="ts">
  import { EventTracking } from "@shared/services/event_tracking/events";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import {
    ProductEntity,
    DistributorEntity,
    MinimumOrderQuantityEntity,
  } from "@shared/services/event_tracking/entities";

  import type { MinimumOrderQuantity } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";

  export let minimumOrderQuantity: MinimumOrderQuantity;
  export let productId: number;
  export let distributorId: number;
  export let sku: string;

  const { trackMrcEvents } = EventTracking;
  const trackingParams = [
    new ProductEntity({ productId }),
    new DistributorEntity({ id: distributorId }),
    new MinimumOrderQuantityEntity({
      label: minimumOrderQuantity.label,
      units: minimumOrderQuantity.units,
      cases: minimumOrderQuantity.cases,
      sleeves: minimumOrderQuantity.sleeves,
      sku: sku,
      messaging_type: "badge",
    }),
  ];
</script>

<TrackingContext entities={trackingParams} let:trackingContext>
  <div class="fizz-stack-8">
    <span
      class="fizz-badge"
      data-testid="minimum-order-quantity-badge"
      use:trackMrcEvents={[trackingContext.entities]}
    >
      {minimumOrderQuantity.label}
    </span>
  </div>
</TrackingContext>
